import "./code_block.css";

const CodeBlock = ({apiInfo}) => {
  return (
    <div className="code-block-container">
      <div className="code-block-header">
        <span className="endpoint">{`/${apiInfo.endpoint}`}</span>
        <span className="language">Python</span>
      </div>
      <pre className="code-block">
        <code>
{`import requests

Url = ${apiInfo.column.length <= 1 
    ? `https://stockarchives-api.com/${apiInfo.endpoint}?authorization=API Token`
    : `https://stockarchives-api.com/${apiInfo.endpoint}?ticker=ticker&authorization=API Token`}
result = requests.get(Url)
parseData = result.json()

`}
        </code>
      </pre>
    </div>
  );
};

export default CodeBlock;